import React, {
  useState,
} from 'react';

import { ReactComponent as CreateIcon } from '../../../assets/icons/v2/creation-plus-circle.svg';
import { PrimaryButton } from '../../../components/Button/ActionButtons';
import {
  HeaderRow,
  TitleContainer,
  SubTitle,
  Title,
} from '../../../components/v2/Header';

import AnnouncementModal from './components/AnnouncementModal';
import AnnouncementList from './components/AnnouncementList';
import {
  Container,
} from './styles';
import texts from './texts.json';

const Announcements = () => {
  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(false);

  return (
    <Container>
      <HeaderRow>
        <TitleContainer>
          <Title>{texts.title}</Title>
          <SubTitle>{texts.subTitle}</SubTitle>
        </TitleContainer>
        <PrimaryButton
          onClick={() => setIsAnnouncementModalOpen(true)}
          icon={<CreateIcon />}
        >
          {texts.newAnnouncement}
        </PrimaryButton>
      </HeaderRow>
      <AnnouncementList />
      {isAnnouncementModalOpen && (
        <AnnouncementModal
          isOpen={isAnnouncementModalOpen}
          onDidDismiss={() => setIsAnnouncementModalOpen(false)}
        />
      )}
    </Container>
  );
};

export default Announcements;
